import React from 'react';
import '../../containers/Header/TitlePage.css';

const styles = {
  errorDiv: {
    marginTop: '50px',
    paddingLeft: '20px',
  },
};


export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.error !== null) {
      // Error path
      return (
        <div style={styles.errorDiv} className="App-header">
          <h2>Something went wrong.</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
          <h2>Please send these error details and steps to reproduce this error to:</h2>
          {/* Next students should get access to this e-mail so */}
          <h3>digitaltriagetool@outlook.com</h3>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/Errors/ErrorBoundary.js